export const enum RegistryOrigin {
	CHECKOUT = 'CHECKOUT',
	REGISTRY = 'REGISTRY',
	LANDING = 'LANDING',
	REGISTRATE = 'REGISTRATE',
}

export const LoginPathNameFromOriginDesktop = {
	[RegistryOrigin.REGISTRY]: '/login',
	[RegistryOrigin.CHECKOUT]: '/checkout/authentication',
	[RegistryOrigin.LANDING]: '/login',
	[RegistryOrigin.REGISTRATE]: '/login',
}
export const LoginPathNameFromOriginMobile = {
	[RegistryOrigin.REGISTRY]: '/login',
	[RegistryOrigin.CHECKOUT]: '/checkout/login',
	[RegistryOrigin.LANDING]: '/login',
	[RegistryOrigin.REGISTRATE]: '/login',
}

export const enum TestIds {
	Title = 'registry.title.text',
	LoginLink = 'registry.loginLink.navigate',
}

export const enum externalRegistryQueryParams {
	secretHash = 'ovs',
	externalId = 'cjext',
}
